import moment from "moment";

import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { LinkedContact } from "@/Common/Api/Patient/Dto/LinkedContact";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { Modal } from "@/Common/Components/Modals/Modal";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { EmployeeTitle } from "@/Common/Models/Employee/Enums/EmployeeTitle";
import { IPatientEnrollmentModel } from "@/Common/Models/Patient/UI/Profile/IPatientEnrollmentModel";
import { RamqStatus } from "@/Common/Models/RAMQ/RAMQInfo";
import { RAMQInscription } from "@/Common/Models/RAMQ/RAMQInscription";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { cacheStore } from "@/Globals/Stores/CacheStore";
import { PatientProfileEnrollmentCaracteristiqueSanteComponent } from "./EnrollmentComponents/PatientProfileEnrollmentCaracteristiqueSanteComponent";
import { PatientProfileEnrollmentClientComponent } from "./EnrollmentComponents/PatientProfileEnrollmentClientComponent";
import { PatientProfileEnrollmentInfoComponent } from "./EnrollmentComponents/PatientProfileEnrollmentInfoComponent";
import { PatientProfileEnrollmentLieuSuiviComponent } from "./EnrollmentComponents/PatientProfileEnrollmentLieuSuiviComponent";
import { PatientProfileEnrollmentRepComponent } from "./EnrollmentComponents/PatientProfileEnrollmentRepComponent";
import { PatientProfileEnrollmentResidentComponent } from "./EnrollmentComponents/PatientProfileEnrollmentResidentComponent";

interface IQuebecPatientEnrollmentProps {
    model: IPatientEnrollmentModel;
}

class QuebecPatientEnrollment extends BaseReactComponent<IQuebecPatientEnrollmentProps, any> {
    public render(): JSX.Element {
        var enrollmentModel = this.props.model;

        if (!enrollmentModel)
            return (<div>{`${cacheStore.GetString("Loading")}...`}</div>);

        const ramqInfo = enrollmentModel.get("RAMQInscription");

        return (
            <div>
                {this.renderPopups()}
                <div className="patient-prof">
                    <div className="scrollable">
                        <div className="psingle-column wider centered">
                            {ramqInfo != null && (
                                <div className="block separated">
                                    <div className="flex-container">
                                        <div style={{ paddingLeft: "10px" }}>
                                            <span>{cacheStore.GetString("LastSynchronizationLabel")}</span>
                                            <strong>{MyleHelper.ReplaceEmptyString(moment(ramqInfo.SyncDate).format("YYYY-MM-DD hh:mm:ss"))}</strong>
                                        </div>
                                        {ramqInfo?.Result == RamqStatus.SubscribedInClinic &&
                                            <div className="text-right" style={{ paddingRight: "10px" }}><a onClick={this.onGenerateRAMQForm.bind(this)}>{cacheStore.GetString("GenerateFormLabel")}</a> | <a onClick={this.onEnrollTerminateClick.bind(this)}> {cacheStore.GetString("TerminateEnrolmentLabel")}</a></div>
                                        }
                                        {ramqInfo?.Result == RamqStatus.SubscribedWithoutVisit &&
                                            <div className="text-right" style={{ paddingRight: "10px", fontWeight: "bold" }}><a onClick={() => this.onEnrollPatientClick()}> Convertir en inscription au médecin de famille</a></div>
                                        }
                                    </div>
                                </div>
                            )}
                            {ramqInfo == null && (
                                <div className="block separated">
                                    <div className="flex-container">
                                        <div className="thin-font" style={{ paddingLeft: "10px" }}>
                                            <h3 style={{ paddingTop: "0px" }}>{cacheStore.GetString("InscriptionRAMQLabel")}</h3>
                                        </div>
                                        <div className="text-right" style={{ paddingRight: "10px" }}><a onClick={this.onGenerateEmptyFormClick.bind(this)}>{cacheStore.GetString("GenerateFormLabel")}</a> | <a onClick={this.onEnrollPatientClick.bind(this)}> {cacheStore.GetString("EnrolPatientLabel")}</a></div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {ramqInfo && (
                            <div className="psingle-column wider centered">
                                {this.GetEnrollmentContents(ramqInfo)}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    private renderPopups(): JSX.Element {
        const enrollmentModel = this.props.model;
        const ramqInfo = enrollmentModel.get("RAMQInscription");
        const terminationTypes = cacheStore.GetRAMQTerminationTypes();

        let selectedResidentIPS = cacheStore.GetEmployeeByContactFacetId(enrollmentModel.get("SelectedResidentId"));
        let IPSinvalid = false;
        if (selectedResidentIPS && Employee.getIssuingOrgRule(selectedResidentIPS).Title === EmployeeTitle.NursePractitioner)
            IPSinvalid = selectedResidentIPS.RamqNumber == null || selectedResidentIPS.RamqNumber.length !== 6;

        // check for ramqErrors
        var ramqErrorsRender: JSX.Element;
        if (enrollmentModel.get("RAMQErrors") && enrollmentModel.get("RAMQErrors").count() > 0) {
            var errors: JSX.Element[] = [];

            errors = enrollmentModel.get("RAMQErrors").toArray().map((x, idx) => (
                <div key={"key" + idx} className="row clear-margin">
                    <div className="col-lg-2 col-md-2 col-sm-2" />
                    <div className="col-lg-8 col-md-8 col-sm-8">
                        {x}
                    </div>
                </div>
            ));

            ramqErrorsRender = (<div>{errors}</div>);
        }

        let isTransmitFormDisabled = false;
        if (enrollmentModel.get("IsEnrollmentFormEdit") == true) {
            if (enrollmentModel.get("EnrollmentEffectiveDate") == null || enrollmentModel.get("EnrollmentEffectiveDate") == undefined) {
                isTransmitFormDisabled = true;
            }
        }

        if (enrollmentModel.get("IsEnrollmentFormEdit") == true || enrollmentModel.get("IsInResidentEditMode") == true) {
            if (!IsNullOrWhiteSpace(enrollmentModel.get("SelectedResidentId")) && IPSinvalid) {
                isTransmitFormDisabled = true;
            }
        }

        if (enrollmentModel.get("IsEnrollmentFormEdit") == true || enrollmentModel.get("IsInRepEditMode") == true) {
            if (!IsNullOrWhiteSpace(enrollmentModel.get("RepFirstName")) || !IsNullOrWhiteSpace(enrollmentModel.get("RepFirstName")) || !IsNullOrWhiteSpace(enrollmentModel.get("SelectedRepTypeId"))) {
                if (IsNullOrWhiteSpace(enrollmentModel.get("RepFirstName")) || IsNullOrWhiteSpace(enrollmentModel.get("RepFirstName")) || IsNullOrWhiteSpace(enrollmentModel.get("SelectedRepTypeId"))) {
                    isTransmitFormDisabled = true; // If one of them is not null they must all be not null
                }
            }
        }

        if (enrollmentModel.get("IsEnrollmentFormEdit") == true || enrollmentModel.get("IsInLieuSuiviEditMode") == true) {
            if (IsNullOrWhiteSpace(enrollmentModel.get("SelectedLieuSuiviId")) || enrollmentModel.get("SelectedLieuSuiviId").length == 0) {
                isTransmitFormDisabled = true;
            }
        }

        return (
            <div>
                {enrollmentModel.get("IsRAMQErrorDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={`${cacheStore.GetString("EnrolmentLabel")}: ${cacheStore.GetString("ErrorLabel")}`}
                        onClose={() => this.onCloseRAMQErrorDialog()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCloseRAMQErrorDialog()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-primary" onClick={() => this.onRAMQErrorDialoModify()}>{cacheStore.GetString("ModifyLabel")} {cacheStore.GetString("EnrolmentLabel")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        {ramqErrorsRender}
                    </Modal>
                )}

                {enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("EnrolmentLabel")}
                        onClose={() => this.onCloseRAMQuestionDialog()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCloseRAMQuestionDialog()}>{cacheStore.GetString("NoLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-primary" onClick={() => this.onRAMQQuestionYesDialog()}>{cacheStore.GetString("YesLabel")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        {ramqErrorsRender}
                    </Modal>
                )}

                {enrollmentModel.get("IsInEnrollmentEditMode") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("lblDateDePriseeffet")}
                        onClose={() => this.onCancelEditOrDelete()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelEditOrDelete()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" disabled={isTransmitFormDisabled} className="btn btn-primary" onClick={() => this.onClickTransmitEnrollmentDate()}>{cacheStore.GetString("TransmitToTheRAMQ")}</button>

                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <PatientProfileEnrollmentInfoComponent model={this.props.model} IsInAddMode={false} IsInEditMode={true} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}

                {enrollmentModel.get("IsInResidentEditMode") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("ModifierResidentLabel")}
                        onClose={() => this.onCancelEditOrDelete()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelEditOrDelete()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" disabled={isTransmitFormDisabled} className="btn btn-primary" onClick={() => this.onClickTransmitEditResident()}>{cacheStore.GetString("TransmitToTheRAMQ")}</button>

                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <PatientProfileEnrollmentResidentComponent model={this.props.model} IsInAddMode={false} IsInEditMode={true} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}

                {enrollmentModel.get("IsInResidentDeleteMode") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("DeleteResidentLabel")}
                        onClose={() => this.onCancelEditOrDelete()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelEditOrDelete()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" className="btn btn-primary" onClick={() => this.onClickTransmitDeleteResident()}>{cacheStore.GetString("TransmitToTheRAMQ")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <PatientProfileEnrollmentResidentComponent model={this.props.model} IsInAddMode={false} IsInEditMode={false} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}

                {enrollmentModel.get("IsInRepEditMode") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("ModifierRepresentantLabel")}
                        onClose={() => this.onCancelEditOrDelete()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelEditOrDelete()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" disabled={isTransmitFormDisabled} className="btn btn-primary" onClick={() => this.onClickTransmitEditRep()}>{cacheStore.GetString("TransmitToTheRAMQ")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <PatientProfileEnrollmentRepComponent model={this.props.model} IsInAddMode={false} IsInEditMode={true} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}

                {enrollmentModel.get("IsInRepDeleteMode") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("DeleteRepresentantLabel")}
                        onClose={() => this.onCancelEditOrDelete()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelEditOrDelete()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" className="btn btn-primary" onClick={() => this.onClickTransmitDeleteRep()}>{cacheStore.GetString("TransmitToTheRAMQ")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <PatientProfileEnrollmentRepComponent model={this.props.model} IsInAddMode={false} IsInEditMode={false} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}

                {enrollmentModel.get("IsInLieuSuiviEditMode") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("ChangeLieuSuiviLabel")}
                        onClose={() => this.onCancelEditOrDelete()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelEditOrDelete()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" disabled={isTransmitFormDisabled} className="btn btn-primary" onClick={() => this.onClickTransmitLieuSuivi()}>{cacheStore.GetString("TransmitToTheRAMQ")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <PatientProfileEnrollmentLieuSuiviComponent model={this.props.model} IsInAddMode={false} IsInEditMode={true} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}

                {enrollmentModel.get("IsInCaracteristiqueSanteEditMode") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("ChangeCaracteristiqueSanteLabel")}
                        onClose={() => this.onCancelEditOrDelete()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelEditOrDelete()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" className="btn btn-primary" onClick={() => this.onClickTransmitCaracteristique()}>{cacheStore.GetString("TransmitToTheRAMQ")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <PatientProfileEnrollmentCaracteristiqueSanteComponent model={this.props.model} IsInAddMode={false} IsInEditMode={true} />
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}

                {enrollmentModel.get("IsEnrollmentFormEdit") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollment"
                        showX
                        centerContent
                        width={650}
                        maxHeight="calc(100vh - 400px)"
                        title={cacheStore.GetString("PatientEnrolmentLabel")}
                        onClose={() => this.onCancelEditOrDelete()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelClick()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button disabled={isTransmitFormDisabled} className="btn btn-primary" onClick={() => this.onTransmitAndPrintClick()}>{cacheStore.GetString("TransmitToTheRAMQAndPrintLavel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" disabled={isTransmitFormDisabled} className="btn btn-primary" onClick={() => this.onClickTransmit()}>{cacheStore.GetString("TransmitToTheRAMQ")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    {this.GetEnrollmentContents(ramqInfo, true, true)}
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}

                {enrollmentModel.get("IsTerminateEnrollmentPopup") && !enrollmentModel.get("IsRAMQErrorDialogVisible") && !enrollmentModel.get("IsRAMQQuestionDialogVisible") && (
                    <Modal
                        showOverlay
                        cssClass="patientEnrollmentTermination"
                        showX
                        centerContent
                        width={550}
                        title={cacheStore.GetString("TerminateEnrolmentLabel")}
                        onClose={() => this.onCancelTerminationClick()}
                        footer={(
                            <div className="display-flex-justified-end">
                                <div className="margin-xs-left">
                                    <button data-action="cancel" className="btn btn-default" onClick={() => this.onCancelTerminationClick()}>{cacheStore.GetString("CancelLabel")}</button>
                                </div>
                                <div className="margin-xs-left">
                                    <button data-action="modify" className="btn btn-primary" onClick={() => this.onTransmitTerminationClick()}>{cacheStore.GetString("CeaseLabel")}</button>
                                </div>
                            </div>
                        )}
                        disableOverlayClose
                        draggable
                    >
                        <div className="p-body">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span>Vous êtes sur le point de cesser cette inscription?</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-3 vcenter text-right">
                                    {cacheStore.GetString("Reason2Label")}
                                </div>
                                <div className="col-lg-9 col-md-9 col-sm-9">
                                    <select onChange={this.onEnrollTerminateChange.bind(this)} className="form-control myle-control" value={enrollmentModel.get("SelectedTerminationId")}>
                                        <option value=""> </option>
                                        {terminationTypes.map((p: [string, string]) => (
                                            <option key={p[0]} value={p[0]}> {p[1]}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        );
    }

    private GetEnrollmentContents(ramqInfo: RAMQInscription, showAdd: boolean = false, showEdit: boolean = false): JSX.Element {
        return (
            <div>
                <div className="block separated">
                    <div className="flex-container heading"><h3 className="h thin-font">{cacheStore.GetString("EnrolmentLabel")}</h3></div>
                    {!showAdd && (
                        <div className="text-right push-right-5">
                            {ramqInfo.Result == 1 &&
                                <a onClick={this.onClickDateEdit.bind(this)}> {cacheStore.GetString("ModifierDateLabel")}</a>
                            }
                        </div>
                    )}
                    <div style={{ paddingLeft: "10px" }}><table className="flextb"><PatientProfileEnrollmentInfoComponent model={this.props.model} IsInAddMode={showAdd} IsInEditMode={showEdit} /></table></div>
                </div>

                <div className="block separated">
                    <div className="flex-container heading"><h3 className="h thin-font">{cacheStore.GetString("DelegatedProfessionalLabel")}</h3></div>
                    {!showAdd && (
                        <div className="text-right push-right-5">
                            <a onClick={this.onClickResidentEdit.bind(this)}> {cacheStore.GetString("EDITLabel")}</a> | <a onClick={this.onClickResidentDelete.bind(this)}> {cacheStore.GetString("DeleteLabel")}</a>
                        </div>
                    )}
                    <div style={{ paddingLeft: "10px" }}>
                        <table className="flextb">
                            <PatientProfileEnrollmentResidentComponent model={this.props.model} IsInAddMode={showAdd} IsInEditMode={showEdit} />
                        </table>
                    </div>
                </div>

                <div className="block separated">
                    {!(showAdd || showEdit) &&
                        <div className="flex-container heading"><h3 className="h thin-font">{cacheStore.GetString("ClientLabel")}</h3></div>
                    }
                    {!(showAdd || showEdit) &&
                        <div style={{ paddingLeft: "10px" }}><table className="flextb"><PatientProfileEnrollmentClientComponent model={this.props.model} IsInAddMode={showAdd} IsInEditMode={showEdit} /></table></div>
                    }
                </div>

                <div className="block separated">
                    <div className="flex-container heading"><h3 className="h thin-font">{cacheStore.GetString("RepresentativeLabel")}</h3></div>
                    {!showAdd && (
                        <div className="text-right push-right-5">
                            <a onClick={this.onClickRepEdit.bind(this)}> {cacheStore.GetString("EDITLabel")}</a> | <a onClick={this.onClickRepDelete.bind(this)}> {cacheStore.GetString("DeleteLabel")}</a>
                        </div>
                    )}
                    <div style={{ paddingLeft: "10px" }}><table className="flextb"><PatientProfileEnrollmentRepComponent model={this.props.model} IsInAddMode={showAdd} IsInEditMode={showEdit} /></table></div>
                </div>

                <div className="block separated">
                    <div className="flex-container heading"><h3 className="h thin-font">{cacheStore.GetString("MainFollowupLocationLabel")}</h3></div>
                    {!showAdd && (
                        <div className="text-right push-right-5">
                            <a onClick={this.onClickLieuSuiviEdit.bind(this)}> {cacheStore.GetString("EDITLabel")}</a>
                        </div>
                    )}
                    <div style={{ paddingLeft: "10px" }}><table className="flextb"><PatientProfileEnrollmentLieuSuiviComponent model={this.props.model} IsInAddMode={showAdd} IsInEditMode={showEdit} /></table></div>
                </div>

                <div className="block separated">
                    <div className="flex-container heading"><h3 className="h thin-font">{cacheStore.GetString("HealthCharacteristicLabel")}</h3></div>
                    {!showAdd && ramqInfo.Result == 1 && (
                        <div className="text-right push-right-5">
                            <a onClick={this.onClickCaracterisqueEdit.bind(this)}> {cacheStore.GetString("ModifyLabel")}</a>
                        </div>
                    )}
                    {!showAdd && ramqInfo.Result == 2 && (
                        <div className="text-center">
                            <span>Vous devez d'abord convertir l'inscription avant d'ajouter un code de vulnérabilité</span>
                        </div>
                    )}

                    <div style={{ paddingLeft: "10px" }}><table className="flextb"><PatientProfileEnrollmentCaracteristiqueSanteComponent model={this.props.model} IsInAddMode={showAdd} IsInEditMode={showEdit} /></table></div>
                </div>
            </div>
        );
    }

    private onCancelClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_EnrollPatientClose);
    }

    private onCancelTerminationClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TerminateEnrollmentCancel);
    }

    private onTransmitTerminationClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TerminateEnrollmentTransmitClick);
    }

    private onCancelEditOrDelete(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_ModifyCancel);
    }

    private onEnrollPatientClick(): void {
        sessionStore.dispatch(LocalPatientOperations.Profile.Enrollment_EnrollPatientClick, { ramqInfo: this.props.model.get("RAMQInscription") });
    }

    private onEnrollTerminateClick(e: React.MouseEvent): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_TerminateEnrollmentClick);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private onEnrollTerminateChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_TerminateEnrollmentChange);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }

    private onClickDateEdit(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_ModifyEnrollmentDateClick);
    }

    private onClickResidentEdit(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_ModifyResidentEditClick);
    }

    private onClickResidentDelete(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_ModifyResidentDeleteClick);
    }

    private onClickRepEdit(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_ModifyRepEditClick);
    }

    private onClickRepDelete(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_ModifyRepDeleteClick);
    }

    private onClickLieuSuiviEdit(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_ModifyLieuSuiviClick);
    }

    private onClickCaracterisqueEdit(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_ModifyCaracteristiqueClick);
    }

    private onClickTransmit(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_EnrollPatientTransmit);
    }

    private onTransmitAndPrintClick(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_EnrollPatientTransmitAndPrint);
    }

    private onClickTransmitEnrollmentDate(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TransmitEnrollmentDateClick);
    }

    private onClickTransmitEditResident(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TransmitEditResidentClick);
    }

    private onClickTransmitDeleteResident(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TransmitDeleteResidentClick);
    }

    private onClickTransmitEditRep(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TransmitEditRepClick);
    }

    private onClickTransmitDeleteRep(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TransmitDeleteRepClick);
    }

    private onClickTransmitLieuSuivi(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TransmitLieuSuiviClick);
    }

    private onClickTransmitCaracteristique(): void {
        LocalEvent.Dispatch(LocalPatientOperations.Profile.Enrollment_TransmitCaracteristiqueClick);
    }

    private onRAMQErrorDialoModify(): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_RAMQErrorDialogGoEdit);
        LocalEventDispatcher.dispatch(operation);
    }

    private onCloseRAMQErrorDialog(): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_CloseRAMQErrorDialog);
        LocalEventDispatcher.dispatch(operation);
    }

    private onRAMQQuestionYesDialog(): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_RAMQQuestionDialogYes);
        LocalEventDispatcher.dispatch(operation);
    }

    private onCloseRAMQuestionDialog(): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_CloseRAMQQuestionDialog);
        LocalEventDispatcher.dispatch(operation);
    }

    private onGenerateEmptyFormClick(): void {
        if (this.verifyQuebecHealthCard())
            sessionStore.dispatch(LocalPatientOperations.Profile.Enrollment_GenerateEmptyFormClick);
    }

    private onGenerateRAMQForm(): void {
        if (this.verifyQuebecHealthCard())
            sessionStore.dispatch(LocalPatientOperations.Profile.Enrollment_GenerateRAMQFormClick);
    }

    private verifyQuebecHealthCard(): boolean {
        const patient = patientStore.PatientProfileIdentifiersModels[this.props.model.get("PatientContactId")];

        if (!patient)
            return false;

        const patientHasValidQcHealthCard = !!patient
            .get("HealthCards")
            .toArray()
            .firstOrDefault(p => p.ProvinceLookupId === cacheStore.FindLookupByLookupCode("CanadaState_QC").LookupID && p.Number?.length === 12);

        const representativeHasValidQcHealthCard = !!patient.get("Representative") && LinkedContact.GetNAM(patient.get("Representative")).length === 12;

        if (!patientHasValidQcHealthCard && !representativeHasValidQcHealthCard) {
            sessionStore.showPopup(this.getString("PatientEnrollment_ValidQuebecHealthCardRequired"));
            return false;
        }

        return true;
    }
}

export { IQuebecPatientEnrollmentProps, QuebecPatientEnrollment };
